import { ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import React, { useCallback } from 'react';

import { ReactComponent as DeleteIcon } from '../../../assets/images/icon-delete-trashbin.svg';
import { ReactComponent as EditIcon } from '../../../assets/images/icon-edit-pencil.svg';
import { IInventoryItem } from '../../../types/inventories';

interface IProps {
  anchorEl: HTMLElement | null;
  menuPosition?: { top: number; left: number } | null;
  selectedItem: IInventoryItem | null;
  canEditInventory: boolean;
  onClose: () => void;
  onEditItem: () => void;
  onDeleteItem: (itemId: string) => void;
  onViewItem: (item: IInventoryItem | null) => void;
}

export const InventoryContextMenu = ({
  anchorEl,
  menuPosition,
  selectedItem,
  canEditInventory,
  onClose,
  onEditItem,
  onDeleteItem,
}: IProps) => {
  const handleContextMenu = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      onClose();
    },
    [onClose],
  );

  const handleEditItem = useCallback(() => {
    onEditItem();
    onClose();
  }, [onClose, onEditItem]);

  const handleDeleteItem = useCallback(() => {
    if (!selectedItem?.item_id) {
      return;
    }
    onDeleteItem(selectedItem.item_id);
    onClose();
  }, [onClose, onDeleteItem, selectedItem]);

  const iconStyles = {
    width: 15,
    height: 15,
  };

  if (!canEditInventory) {
    return null;
  }

  return (
    <Menu
      anchorEl={anchorEl}
      open={!!(anchorEl || menuPosition)}
      onClose={onClose}
      onContextMenu={handleContextMenu}
      anchorReference={menuPosition ? 'anchorPosition' : 'anchorEl'}
      anchorPosition={menuPosition || undefined}
      autoFocus={false}
      disableAutoFocus={true}
      disableEnforceFocus={true}
      disableRestoreFocus={true}
    >
      <MenuItem onClick={handleEditItem} data-action="context_menu_edit">
        <ListItemIcon>
          <EditIcon style={{ ...iconStyles }} />
        </ListItemIcon>
        <ListItemText>Edit</ListItemText>
      </MenuItem>

      <MenuItem onClick={handleDeleteItem} data-action="context_menu_delete">
        <ListItemIcon>
          <DeleteIcon style={{ ...iconStyles }} />
        </ListItemIcon>
        <ListItemText>Delete</ListItemText>
      </MenuItem>
    </Menu>
  );
};
